import { useEffect, useState, forwardRef } from "react";
import { Dialog, AppBar, Toolbar, IconButton, Typography, DialogContent, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import Zelle from "./Zelle";
import PreviewPayment from "./PreviewPayment";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PaymentDialog = ({ open, close, method, invoiceId }) => {

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={close}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1 }}>
            {method === "ach"
              ? "Pay with ACH"
              : method === "card"
              ? "Pay with Credit Card"
              : "Pay with Zelle"}
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        {method === "ach" && (
          <PreviewPayment
            invoiceId={invoiceId}
            method="us_bank_account"
     
          />
        )}
        {method === "card" && (
          <PreviewPayment
            invoiceId={invoiceId}
            method="card"
         
          />
        )}
        {method === "zelle" && (
          <Zelle />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDialog;
